export default function walletTransactionDetailRows(item, format) {
  if (!item) return []

  return [
    { label: 'İşlem ID', value: item.id ? `#${item.id}` : '-' },
    { label: 'Transaction ID', value: item.transactionId || '-' },
    { label: 'Event ID', value: item.providerEventId || '-' },
    { label: 'Unique ID', value: item.uniqueId || '-' },
    { label: 'Link ID', value: item.linkId ? `#${item.linkId}` : '-' },
    { label: 'Link Unique ID', value: item.linkUniqueId || '-' },
    { label: 'Link / İşlem', value: item.linkName || '-' },
    { label: 'Kampanya', value: item.campaignName || '-' },
    { label: 'Durum', value: format.formatDashboardStatus(item.status) },
    { label: 'Network Durumu', value: item.observedStatusRaw || item.observedStatus || '-' },
    { label: 'Network', value: item.networkSource || '-' },
    { label: 'Kullanıcı Hakedişi', value: format.formatMoney(item.amount) },
    {
      label: 'Network Hakedişi',
      value: item.networkPayoutAmount === null || item.networkPayoutAmount === undefined
        ? '-'
        : format.formatMoney(item.networkPayoutAmount),
    },
    { label: 'Satış Tutarı', value: format.formatMoney(item.saleAmount) },
    { label: 'Kullanıcı Payout', value: format.formatPayout(item.appliedPayout, item.appliedPayoutType) },
    { label: 'Network Payout', value: format.formatPayout(item.networkPayout, item.appliedPayoutType) },
    { label: 'Payout Tipi', value: item.appliedPayoutType || '-' },
    { label: 'Payout Tier', value: item.appliedTier || '-' },
    { label: 'Self purchase', value: format.formatBoolean(item.selfPurchase) },
    { label: 'Adjustment', value: format.formatBoolean(item.adjustment) },
    { label: 'Kullanıcıda görünür', value: format.formatBoolean(item.userVisible) },
    { label: 'Görünürlük kararı', value: item.visibilityBasis || '-' },
    { label: 'İlk Görülme', value: format.formatDateTime(item.firstSeenAt) },
    { label: 'Son Görülme', value: format.formatDateTime(item.lastSeenAt) },
    { label: 'Settlement Uygunluk', value: format.formatDateTime(item.settlementEligibleAt) },
    { label: 'Mutabakat Bitişi', value: format.formatDateTime(item.reconciliationExpiresAt) },
    { label: 'Son Mutabakat Kontrolü', value: format.formatDateTime(item.lastReconciledAt) },
    { label: 'Eksik Gözlem Sayısı', value: item.missingObservationCount || 0 },
    { label: 'İlk Eksik Gözlem', value: format.formatDateTime(item.firstMissingAt) },
    { label: 'Son Eksik Gözlem', value: format.formatDateTime(item.lastMissingAt) },
    { label: 'Kesinleşme', value: format.formatDateTime(item.confirmedAt) },
    { label: 'İptal', value: format.formatDateTime(item.cancelledAt) },
    { label: 'Suppressed Reason', value: item.suppressedReason || '-' },
    { label: 'Not', value: item.note || '-' },
  ]
}
